import { _ as __rest, a as __assign } from './tslib.es6-21effb23.js';
import * as React from 'react';

var ChevronRightIcon = function (_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.23713 1.42024C7.79745 0.859921 8.7059 0.859921 9.26622 1.42024L18.8314 10.9855C19.3918 11.5458 19.3918 12.4542 18.8314 13.0145L9.26622 22.5798C8.7059 23.1401 7.79745 23.1401 7.23713 22.5798C6.67682 22.0194 6.67682 21.111 7.23713 20.5507L15.7878 12L7.23713 3.44933C6.67682 2.88901 6.67682 1.98056 7.23713 1.42024Z", fill: fillColor })));
};

export { ChevronRightIcon as C };
